import { useCallback, useEffect, useState } from "react";
import { restServices } from "../../../cuba/services";
import { PersonGroupExt } from "../../../cuba/entities/base/base$PersonGroupExt";

function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export function useSearchHandler() {
  const [searchValue, setSearchValue] = useState<string>("");
  const [options, setOptions] = useState<PersonGroupExt[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const debouncedSearchValue = useDebounce(searchValue, 600);

  useEffect(() => {
    let cancelled = false;

    if (debouncedSearchValue.length > 3) {
      setLoading(true);

      restServices.assignmentSalaryRequestService
        .findPerson(debouncedSearchValue, "empty", "_minimal")
        .then((res) => {
          if (!cancelled) {
            const unique = (res || []).filter(
              (item, index, self) =>
                index === self.findIndex((el) => el.id === item.id),
            );

            setOptions(unique);
          }
        })
        .catch((error) => {
          if (!cancelled) {
            console.error("Error fetching data:", error);
            setOptions([]);
          }
        })
        .finally(() => {
          if (!cancelled) {
            setLoading(false);
          }
        });
    } else {
      setOptions([]);
    }

    return () => {
      cancelled = true;
    };
  }, [debouncedSearchValue]);

  const handleSearch = useCallback((value: string) => {
    setOptions([]);
    setSearchValue(value);
  }, []);

  return { debouncedSearchValue, handleSearch, options, loading };
}
